import React, { Component } from 'react'
// import classNames from 'classnames'
// import CircularProgress from '@material-ui/core/CircularProgress'

class Button extends Component {
    render() {
        const {
            children,
            type,
            error,
            background,
            isLoading,
            text,
            className,
            padding,
            onClick
        } = this.props

        return (
            <>
                <button
                    type={type}
                    className={className}
                    style={{
                        backgroundColor: background,
                        color: text,
                        padding
                    }}
                    onClick={onClick}
                >
                    {children}
                </button>
            </>
        )
    }
}

export default Button
